import { z } from 'zod'

export const EmptyArraySchema = z.array(z.void()).length(0)
